'use client'

import MUIStack from '@mui/material/Stack'
import { AccountMenu } from '../AccountMenu/AccountMenu'
import { NavigationSidebarItem } from '../NavigationSidebarItem/NavigationSidebarItem'
import { SupportIcon } from '@repo/ui/SupportIcon'

export const NavigationSidebarItemsBottom = () => {
  return (
    <MUIStack direction={'column'} alignItems="center" spacing={0} data-testid="NavigationSidebarItemsBottom">
      <NavigationSidebarItem
        label="Support"
        menuKey="support"
        menuHeight={'auto'}
        icon={<SupportIcon sx={{ color: 'white' }} />}
        shift={-140}
      />

      <AccountMenu />
    </MUIStack>
  )
}
